// ============================================================
// Designations API
// ============================================================

import client from './axios';

export const designationsApi = {
  getAll: async (schoolId, params = {}) => {
    const response = await client.get('/designations/', {
      params: { school_id: schoolId, ...params },
    });
    return response.data;
  },

  getById: async (id, schoolId) => {
    const response = await client.get(`/designations/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  create: async (schoolId, payload) => {
    const response = await client.post(`/designations/?school_id=${schoolId}`, payload);
    return response.data;
  },

  update: async (id, schoolId, payload) => {
    const response = await client.put(`/designations/${id}?school_id=${schoolId}`, payload);
    return response.data;
  },

  delete: async (id, schoolId) => {
    const response = await client.delete(`/designations/${id}?school_id=${schoolId}`);
    return response.data;
  },
};
